// toimitilat-filters.js
(function () {
  const grid =
    document.getElementById('toimitilat-grid') ||
    document.querySelector('.grid-wrapper');

  if (!grid) return;

  const getCards = () =>
    Array.from(grid.querySelectorAll('.grid-item[id^="search-result-"]'));

  const elPropertyType = document.getElementById('propertyType');
  const elAreaMin = document.getElementById('areaMin');
  const elAreaMax = document.getElementById('areaMax');
  const elIsNew = document.getElementById('isNewConstruction');
  const elSearch = document.getElementById('searchText');

  const elCountNumber = document.querySelector('.count-number');
  const elPlural = document.querySelector('.count-text-plural');
  const elCountText = document.querySelector('.count-text');
  const elNoResults = document.querySelector('.no-results');

  const cityPills = Array.from(document.querySelectorAll('.city[data-city]'));

  const toNum = (v) => {
    const n = Number(String(v ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };

  const normalize = (s) => String(s ?? '').trim().toLowerCase();

  function cardMatches(card, filters) {
    if (filters.propertyType) {
      const tokens = normalize(card.dataset.propertyTypes || '')
        .split(',')
        .map((t) => t.trim());
      if (!tokens.includes(filters.propertyType)) return false;
    }

    if (filters.isNewConstruction && card.dataset.isNew !== '1') return false;

    const areaMin = toNum(card.dataset.areaMin);
    const areaMax = toNum(card.dataset.areaMax);

    if (filters.areaMin != null && areaMax != null && areaMax < filters.areaMin)
      return false;
    if (filters.areaMax != null && areaMin != null && areaMin > filters.areaMax)
      return false;

    if (filters.searchText) {
      const hay =
        normalize(card.dataset.city) +
        ' ' +
        normalize(card.dataset.district) +
        ' ' +
        normalize(card.dataset.address);
      if (!hay.includes(filters.searchText)) return false;
    }

    if (filters.city && normalize(card.dataset.city) !== filters.city)
      return false;

    return true;
  }

  function getFilters() {
    return {
      propertyType: normalize(elPropertyType?.value),
      areaMin: toNum(elAreaMin?.value),
      areaMax: toNum(elAreaMax?.value),
      isNewConstruction: !!elIsNew?.checked,
      searchText: normalize(elSearch?.value),
      city: normalize(grid.dataset.activeCity || ''),
    };
  }

  function setCount(n) {
    if (elCountNumber) elCountNumber.textContent = String(n);
    if (elCountText) elCountText.textContent = (n === 1) ? 'tulos' : 'tulosta';
  }

  function setNoResults(show) {
    if (!elNoResults) return;
    elNoResults.classList.toggle('hidden', !show);
  }

  function applyFilters() {
    const cards = getCards();
    const filters = getFilters();

    let matched = 0;

    cards.forEach((card) => {
      const ok = cardMatches(card, filters);
      card.style.display = ok ? '' : 'none';
      if (ok) matched++;
    });

    setCount(matched);

    if (matched === 0) {
      setNoResults(true);
      cards.forEach((c) => (c.style.display = ''));
      setCount(cards.length);
    } else {
      setNoResults(false);
    }

    // 🔁 Swiper refresh after DOM changes
    window.updateSwipers && window.updateSwipers();
  }

  const on = (el, evt, fn) => el && el.addEventListener(evt, fn);

  on(elPropertyType, 'change', applyFilters);
  on(elAreaMin, 'input', applyFilters);
  on(elAreaMax, 'input', applyFilters);
  on(elIsNew, 'change', applyFilters);
  on(elSearch, 'input', applyFilters);

  cityPills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const city = normalize(pill.dataset.city);
      const current = normalize(grid.dataset.activeCity || '');
      grid.dataset.activeCity = current === city ? '' : city;

      cityPills.forEach((p) =>
        p.classList.remove('ring-2', 'ring-indigo-400')
      );
      if (grid.dataset.activeCity)
        pill.classList.add('ring-2', 'ring-indigo-400');

      applyFilters();
    });
  });

  document.addEventListener('DOMContentLoaded', applyFilters);
})();